<template>
    <v-overlay id="overlay" opacity="0.35" :absolute="true" z-index="51" class="text-center">

        <h2>Prosím, nejprve naplňte záložku <b> Základní entity </b> daty.</h2>

    </v-overlay>

</template>

<script>
    export default {
        name: "StudyOverlay"
    }
</script>

<style scoped>

    #overlay {
        -webkit-box-shadow: 8px 36px 49px -6px rgba(0,0,0,0.71);
        -moz-box-shadow: 8px 36px 49px -6px rgba(0,0,0,0.71);
        box-shadow: 8px 36px 49px -6px rgba(0,0,0,0.71);
    }

</style>
